import { Accordion, Typography, tk } from '@sunwebgroup/ui-components';
import { GoodToKnow } from './GoodToKnow';
import { Mealplans } from './Mealplans';
import { SurroundingsInformation } from './SurroundingsInformation';
import { styled } from 'styled-components';
import { FlightInfo } from './FlightInfo';
import { CountryInfo } from './CountryInfo';
import { useCMSPageField } from '@/cms/fields';

const Wrapper = styled.div``;

const Title = styled(Typography)`
  margin-bottom: ${tk('spacing_lg')} !important;
  @media ${tk('mq_tablet')} {
    margin-bottom: unset;
  }
`;

export default function PracticalInformation() {
  const data = useCMSPageField('PDP.PracticalInformation');

  return (
    <Wrapper>
      {data?.headerTitle && (
        <Title as="h2" $variant="heading-md">
          {data.headerTitle}
        </Title>
      )}
      <Accordion.Root>
        {data?.goodToKnowTitle && <GoodToKnow title={data.goodToKnowTitle} />}
        {data?.mealplansTitle && <Mealplans title={data.mealplansTitle} />}
        {data?.flightInformation && <FlightInfo {...data.flightInformation} />}
        {data?.surroundingsTitle && <SurroundingsInformation title={data.surroundingsTitle} />}
        {data?.countryInformation && <CountryInfo {...data.countryInformation} />}
      </Accordion.Root>
    </Wrapper>
  );
}
